// Module
var code = "<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <rect x=\"5.5\" y=\"5.5\" width=\"19\" height=\"19\" rx=\"9.5\" stroke=\"#FF6250\"/> </svg> ";
// Exports
module.exports = code;